'use strict';

require("core-js/modules/es6.string.small");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Mark = exports.Char = exports.Label = exports.Heading = exports.Content = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _util = require('../util');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var contentStyles = function contentStyles(theme) {
  return {
    _root: {},
    root: {
      fontSize: theme.smallText,
      width: '100%',
      wordWrap: 'break-word',
      whiteSpace: 'pre-wrap',
      '&:focus': {
        outline: 0
      },
      '&:empty': {
        display: 'none'
      },
      '& iframe, & img': {
        maxwidth: '100%'
      }
    },
    wrap: {
      padding: theme.cardPadding,
      textAlign: 'center',
      fallbacks: {
        padding: 20
      }
    },
    divider: {
      borderTop: theme.cardBorder
    },
    small: {
      fontSize: theme.smallText
    },
    medium: {
      fontSize: theme.mediumText
    },
    large: {
      fontSize: theme.largeText
    }
  };
};

var headingStyles = function headingStyles(theme) {
  return _defineProperty({
    _root: {},
    root: {
      background: theme.bgCardTitle,
      color: theme.colorCardTitle,
      borderTopLeftRadius: theme.cardBorderRadius,
      borderTopRightRadius: theme.cardBorderRadius,
      fontWeight: 'bold',
      fontSize: 20,
      fontFamily: theme.fontSecondary,
      padding: [[15, 20]],
      textAlign: 'center',
      textTransform: 'uppercase',
      width: '100%',
      boxSizing: 'border-box'
    },
    hasLabels: {
      padding: [[8, 20]]
    },
    wrapper: {
      width: '100%',
      position: 'sticky',
      top: 0,
      zIndex: 100
    }
  }, '@media(max-width: ' + theme.sidebarBreakpoint + 'px)', {
    wrapper: {
      top: 45
    }
  });
};

var markStyles = function markStyles(theme) {
  return {
    _root: {},
    root: {
      boxDecorationBreak: 'clone',
      color: 'inherit',
      display: 'inline',
      fontWeight: 'bold',
      lineHeight: 1,
      margin: [[0, '0.15em']],
      padding: [['0.25em', '0.4em']],
      background: theme.bgHighlight
    },
    outside: {
      background: theme.bgLowlight
    },
    rtl: {
      margin: 0
    }
  };
};

var labelStyles = function labelStyles(theme) {
  return {
    _root: {},
    root: {
      color: theme.colorHighlightLabel,
      fontWeight: 'bold',
      fontSize: '0.675em',
      fontFamily: theme.fontSecondary,
      marginLeft: 8,
      textTransform: 'uppercase',
      verticalAlign: 'middle'
    },
    rtl: {
      marginLeft: 0,
      verticalAlign: 'baseline'
    }
  };
};

var charStyles = function charStyles(theme) {
  return {
    root: {
      opacity: 0.5,
      lineHeight: 1,
      verticalAlign: 'middle',
      padding: [[0, 5]],
      fontSize: 8
    }
  };
};

function _Content(props) {
  var _classNames;

  var children = props.children,
      nowrap = props.nowrap,
      divider = props.divider,
      textSize = props.textSize,
      _props$cardStyle = props.cardStyle,
      cardStyle = _props$cardStyle === undefined ? {} : _props$cardStyle,
      classes = props.classes,
      className = props.className,
      theme = props.theme,
      restProps = _objectWithoutProperties(props, ['children', 'nowrap', 'divider', 'textSize', 'cardStyle', 'classes', 'className', 'theme']);

  var rootClassNames = (0, _classnames2["default"])('prodigy-content', classes.root, classes._root, className, (_classNames = {}, _defineProperty(_classNames, classes.wrap, !nowrap), _defineProperty(_classNames, classes.divider, divider), _defineProperty(_classNames, classes.small, !nowrap && textSize == 'small'), _defineProperty(_classNames, classes.medium, !nowrap && textSize == 'medium'), _defineProperty(_classNames, classes.large, !nowrap && textSize == 'large'), _classNames));
  return _react2["default"].createElement('div', _extends({
    className: rootClassNames,
    style: cardStyle
  }, restProps), children);
}

function _Heading(_ref2) {
  var toolbar = _ref2.toolbar,
      hasLabels = _ref2.hasLabels,
      children = _ref2.children,
      classes = _ref2.classes,
      className = _ref2.className;
  var headingClassNames = (0, _classnames2["default"])('prodigy-title', classes.root, classes._root, className, _defineProperty({}, classes.hasLabels, hasLabels));
  return _react2["default"].createElement('div', {
    className: (0, _classnames2["default"])('prodigy-title-wrapper', classes.wrapper)
  }, _react2["default"].createElement('div', {
    className: headingClassNames
  }, children), toolbar);
}

function _Mark(props) {
  var _classNames3;

  var children = props.children,
      label = props.label,
      outside = props.outside,
      color = props.color,
      classes = props.classes,
      className = props.className,
      theme = props.theme,
      writingDir = props.writingDir,
      restProps = _objectWithoutProperties(props, ['children', 'label', 'outside', 'color', 'classes', 'className', 'theme', 'writingDir']);

  var background = color || theme.labels[label];
  var style = background && {
    background: background
  };
  var rootClassNames = (0, _classnames2["default"])(classes.root, classes._root, className, (_classNames3 = {}, _defineProperty(_classNames3, classes.outside, outside), _defineProperty(_classNames3, classes.rtl, writingDir == 'rtl'), _classNames3));
  return _react2["default"].createElement('mark', _extends({
    className: rootClassNames,
    style: style
  }, restProps), children);
}

function _Label(_ref3) {
  var children = _ref3.children,
      writingDir = _ref3.writingDir,
      classes = _ref3.classes,
      className = _ref3.className;
  var rootClassNames = (0, _classnames2["default"])(classes.root, classes._root, className, _defineProperty({}, classes.rtl, writingDir == 'rtl'));
  return _react2["default"].createElement('span', {
    className: rootClassNames
  }, children);
}

function _Char(_ref4) {
  var children = _ref4.children,
      classes = _ref4.classes;
  return _react2["default"].createElement('span', {
    className: classes.root
  }, children);
}

var Content = exports.Content = (0, _util.withStyles)(contentStyles)(_Content);
var Heading = exports.Heading = (0, _util.withStyles)(headingStyles)(_Heading);
var Label = exports.Label = (0, _util.withStyles)(labelStyles)(_Label);
var Char = exports.Char = (0, _util.withStyles)(charStyles)(_Char);
var Mark = exports.Mark = (0, _util.withStyles)(markStyles)(_Mark);